import { FC } from "react";
import { Link, useLocation } from "react-router-dom";

import classes from "./BottomNav.module.css";
import { getLang, i18n } from "../../i18n";

const BottomNav: FC = () => {
  const lang = getLang();
  const t = i18n.bottomNav[lang];

  const location = useLocation();
  if (location.pathname === "/vote") return <></>;
  return (
    <nav className={`${classes.bottomNav}`}>
      <Link to="/" className={location.pathname === "/" ? classes.current : ""}>
        <svg viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            className={classes.stroke}
            d="M5.02885 20.0032C5.24962 21.5877 6.68271 22 7.42857 22H20.2653C20.7279 22 22 21.6531 22 20.2653V18.8776M5.02885 20.0032C5.01001 19.868 5 19.7242 5 19.5714C5 16.2177 5 9.37143 5 7.42857C5 5.48571 6.61905 5 7.42857 5H19.5714C20.381 5 22 5.48571 22 7.42857V18.8776M5.02885 20.0032L8.81633 15.4082C9.04762 15.1769 9.64898 14.8531 10.2041 15.4082C10.7592 15.9633 11.9388 17.1429 12.4592 17.6633C12.5748 17.7789 12.8755 17.9408 13.1531 17.6633L16.102 13.6735C16.2755 13.5 16.9347 13.1184 17.4898 13.6735L21.6531 17.8367C21.7687 17.9524 22 18.3224 22 18.8776"
            strokeWidth="1.5"
          />
        </svg>
        <span>{t.gallery}</span>
      </Link>

      <Link
        to="/quizzes"
        className={
          location.pathname.startsWith("/quizzes") ? classes.current : ""
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-0.5 -0.5 16 16"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            className={classes.stroke}
            d="M13.125 1.875v3.125l-6.875 5.625 -2.5 2.5 -1.875 -1.875 2.5 -2.5 5.625 -6.875z"
            strokeWidth=".83"
          />
          <path
            className={classes.stroke}
            d="m3.125 8.125 3.75 3.75"
            strokeWidth=".83"
          />
          <path
            className={classes.stroke}
            d="M8.95 10.825 11.25 13.125l1.875 -1.875 -2.1031250000000004 -2.1031250000000004"
            strokeWidth=".83"
          />
          <path
            className={classes.stroke}
            d="M6.25 3.4375 5 1.875H1.875v3.125l1.875 1.5625"
            strokeWidth=".83"
          />
        </svg>
        <span>{t.quizzes}</span>
      </Link>

      <Link
        to="/vote"
        className={`${classes.vote} ${
          location.pathname === "/vote" ? classes.inactive : ""
        }`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27" fill="none">
          <path
            className={classes.fill}
            d="M11.2251 3C10.9442 3.99213 9.87684 6.80315 7.85446 10.1102C5.83207 13.4173 5.32651 15.2362 5.15795 15.7323C4.92025 16.4317 4.85459 18.2787 5.66354 19.8661C6.33767 21.189 8.21682 23.5039 10.3825 23.5039C9.04455 21.8631 9.04468 20.631 9.04476 19.8834L9.04477 19.8661C9.04477 18.2126 10.6391 15.4016 10.8986 15.4016C11.1581 15.4016 12.0116 17.2205 12.2363 17.8819C12.6296 17.5512 13.5 16.5 13.7531 14.5748C13.8093 13.748 13.7637 11.2677 13.7637 11.2677C13.7637 10.937 13.9217 10.8819 14.0902 10.937C14.8205 11.4331 16.2474 13.0205 17.4608 16.063C18.6743 19.1055 16.1231 22.5118 15.607 23.1732L14.9434 24C15.8872 24 17.4047 23.5039 17.9664 23.1732C20.6629 21.5858 21 18.2126 21 16.7244C21 15.7323 20.6292 13.1528 18.472 10.1102C16.3148 7.06772 12.7419 4.10236 11.2251 3Z"
          />
        </svg>
        <span>{t.vote}</span>
      </Link>

      <Link
        to="/leaderboard"
        className={
          location.pathname.startsWith("/leaderboard") ? classes.current : ""
        }
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27" fill="none">
          <path
            className={classes.stroke}
            d="M8.53379 17.014L7.67934 21.9738C7.67934 22.4869 7.67934 23 8.53379 23C8.83874 23 12.6351 20.7766 12.9769 20.6056C13.7972 20.1951 14.6858 20.4346 15.0276 20.6056C15.3694 20.7766 19.1657 23 19.4707 23C20.3251 23 20.3251 22.4869 20.3251 21.9738L19.4707 17.014C19.4707 16.8429 19.2998 16.3299 19.8125 15.8168L23.572 12.0541C23.9708 11.598 24.4265 10.8569 23.2302 10.6859L17.7572 9.83074C17.0737 9.65971 16.7319 8.97559 16.561 8.63354L14.6812 4.52883C14.1344 3.57107 13.542 4.12976 13.3141 4.52883L11.2635 8.63354C11.0926 8.97559 10.9217 9.65971 10.2381 9.83074L4.76975 10.6859C3.57353 10.8569 4.02923 11.598 4.42798 12.0541L8.18754 15.8168C8.7002 16.3299 8.53379 16.8429 8.53379 17.014Z"
            strokeWidth="1.5"
          />
        </svg>
        <span>{t.leaderboard}</span>
      </Link>

      <Link
        to="/wallet"
        className={
          location.pathname.startsWith("/wallet") ? classes.current : ""
        }
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27" fill="none">
          <rect
            x="6"
            y="7"
            width="12"
            height="15"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <rect
            x="9"
            y="5"
            width="12"
            height="15"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <rect
            x="12"
            y="3"
            width="12"
            height="15"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </svg>
        <span>{t.wallet}</span>
      </Link>
    </nav>
  );
};

export default BottomNav;
